import { render, staticRenderFns } from "./DatosQR.vue?vue&type=template&id=74737fbf&"
import script from "./DatosQR.vue?vue&type=script&lang=js&"
export * from "./DatosQR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports